module.exports = {
    maxMemory: parseInt(process.env.API_CACHE_MAX_MEMORY) || 2000000000, // 2GB
    maxAge: process.env.CACHE_MAX_AGE ? process.env.CACHE_MAX_AGE * 1000 : 360000000, // 100 hours by default
    entitiesMaxAge: {
        winnerList: process.env.CACHE_MAX_AGE_MINUTES_WINNER_LIST ? process.env.CACHE_MAX_AGE_MINUTES_WINNER_LIST * 60 * 1000 : 3600 * 1000, // 1 hour by default
    },
};